import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CsiteSupplier } from '@arpada/arp-lib-common-qupro';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { IonicSelectableComponent } from 'ionic-selectable';
import { MessagesService } from '../../../services/api.services';


@Component({
  selector: 'app-selector-csite',
  templateUrl: './selector-csite.component.html',
  styleUrls: ['./selector-csite.component.scss'],
})
export class SelectorCsiteComponent implements OnInit {

  @Input() isModal;
  @Input() afterLogin;
  @Input() csites: CsiteSupplier[];

  @ViewChild('csitesSelectable', { static: true }) csitesSelectable: IonicSelectableComponent;

  private modalId: string = null;

  constructor(private modalCtrl: ModalController,
              private router: Router,
              private messages: MessagesService) { }

  ngOnInit() {
    this.messages.onInitTranslateService().subscribe( () => {
      this.modalCtrl.getTop().then((top: HTMLIonModalElement) => {
        this.modalId = top.id; // Get modal ID for close it
      });
    });
  }

  onSelectCsitesId(eventSelectable: {component: IonicSelectableComponent, isSelected: boolean, item: CsiteSupplier}) {
    if (eventSelectable.isSelected) {
      this.router.navigate(['main', 'issues-nueva-proforma', eventSelectable.item.id]);
      this.dismiss();
    }
  }

  dismiss() {
    this.modalCtrl.dismiss({
      dismissed: true
    }, null, this.modalId);
  }

}
